import React from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CsLineIcons from '../../cs-line-icons';
import NotificationItem from "./item";
import { read as readNotifications, readAll as readAllNotifications, get as getNotifications } from '../../actions/notification';
import "./style.css";

class Notifications extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showing: props?.showing || false,
            items: props?.items || []
        }
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.onDocumentMouseDown);
        this.props.getNotifications();
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.onDocumentMouseDown);
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.showing || false) !== (this.props?.showing || false)) {
            this.setState({
                showing: this.props.showing
            });
        }

        if (prevProps.items !== this.props.items) {
            this.setState({
                items: this.props.items || []
            });
        }
    }

    onDocumentMouseDown = (event) => {
        if (!this.state.showing) return;
        if (this.wrapperRef.current?.contains(event.target)) return;
        this.setState({ showing: false });
    };

    onToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState((prev) => ({
            showing: !prev.showing
        }));
    };

    onRead = (id) => {
        if (!id) return;
        this.props.readNotifications(id);
    }

    onReadAll = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.readAllNotifications(this.state.items.map((item) => item.uuid));
    };

    onFooterClick = () => {
        this.setState({ showing: false });
    };

    renderPanel = () => {
        const { items } = this.state;
        const count = items.length;
        const caption = count === 1 ? "1 New notification" : `${count} New notifications`;

        return (
            <div className={`wide notification-dropdown dropdown-menu dropdown-menu-end${this.state.showing ? " show" : ""}`}>
                <div className="notification-dropdown-header">
                    <div className="notification-dropdown-title">{count ? caption : "No new notifications"}</div>
                </div>
                <div className="notification-dropdown-body">
                    <button
                        type="button"
                        className="notification-dropdown-action"
                        onClick={this.onReadAll}
                        disabled={!count}
                    >
                        Set all as read
                    </button>
                    <div className="notification-dropdown-divider" />
                    {count ? (
                        <div className="notification-scroll">
                            <ul className="notification-list list-unstyled">
                                {items.map((item) =>
                                    <NotificationItem
                                        key={`notificationItem.${item.uuid}`}
                                        onRead={this.onRead}
                                        id={item.uuid}
                                        style={item.style}
                                        title={item.title}
                                        description={item.description}
                                        activeDate={item.activeDate}
                                    />
                                )}
                            </ul>
                        </div>
                    ) : (
                        <div className="notification-empty">You're all caught up.</div>
                    )}
                    <Link to="/dashboard/notifications" className="notification-footer-link" onClick={this.onFooterClick}>
                        See all notifications
                    </Link>
                </div>
            </div>
        );
    };

    render() {
        const count = this.state.items.length;

        return (
            <li ref={this.wrapperRef} className="list-inline-item dropdown notification-nav-item">
                <button
                    type="button"
                    className="notification-button border-0 bg-transparent"
                    aria-label="Notifications"
                    aria-expanded={this.state.showing}
                    onClick={this.onToggle}
                >
                    <div className="position-relative d-inline-flex">
                        <CsLineIcons icon="bell" size="18" />
                        {count ? <span className="position-absolute notification-dot rounded-xl" /> : null}
                    </div>
                </button>
                {this.renderPanel()}
            </li>
        )
    }
}

Notifications.propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object,
    items: PropTypes.array,
    readNotifications: PropTypes.func.isRequired,
    readAllNotifications: PropTypes.func.isRequired,
    getNotifications: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth,
        profile: state.licensee.profile,
        notification: state.notification,
        items: state.notification.items
    });
};

export default connect(mapStateToProps, { readNotifications, readAllNotifications, getNotifications })(Notifications);
